import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import TrialsByEnrollment from '@/components/Trials/Enrollments/Archive'
import TrialsByEnrollmentSpecific from '@/components/Trials/Enrollments/Singular'
import TrialsByLocation from '@/components/Trials/Locations/Archive'
import TrialsByLocationSpecific from '@/components/Trials/Locations/Singular'
import TrialsByIndication from '@/components/Trials/Indications/Archive'
import TrialsByIndicationSpecific from '@/components/Trials/Indications/Singular'
import TrialsByInvestigator from '@/components/Trials/Investigators/Archive'
import TrialsByInvestigatorSpecific from '@/components/Trials/Investigators/Singular'
import TrialsByCoordinator from '@/components/Trials/Coordinators/Archive'
import TrialsByCoordinatorSpecific from '@/components/Trials/Coordinators/Singular'
import Trial from '@/components/Trials/Trial'
import EditTrial from '@/components/Trials/Edit/EditTrial'
import Trials from '@/components/Trials/Trials'
import CreateTrial from '@/components/Trials/CreateTrial'
import Enrollment from '@/components/Enrollments/Enrollment'
import Enrollments from '@/components/Enrollments/Enrollments'
import CreateEnrollment from '@/components/Enrollments/CreateEnrollment'
import Location from '@/components/Locations/Location'
import Locations from '@/components/Locations/Locations'
import CreateLocation from '@/components/Locations/CreateLocation'
import Indication from '@/components/Indications/Indication'
import Indications from '@/components/Indications/Indications'
import CreateIndication from '@/components/Indications/CreateIndication'
import Investigator from '@/components/Investigators/Investigator'
import Investigators from '@/components/Investigators/Investigators'
import CreateInvestigator from '@/components/Investigators/CreateInvestigator'
import Coordinator from '@/components/Coordinators/Coordinator'
import Coordinators from '@/components/Coordinators/Coordinators'
import CreateCoordinator from '@/components/Coordinators/CreateCoordinator'
import Alert from '@/components/Alert/Alert'
import Alerts from '@/components/Alert/Alerts'
import CreateAlert from '@/components/Alert/CreateAlert'
import Profile from '@/components/User/Profile'
import SignIn from '@/components/User/SignIn'
import SignUp from '@/components/User/SignUp'
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Trials/Enrollments',
      name: 'TrialsByEnrollment',
      component: TrialsByEnrollment
    },
    {
      path: '/Trials/enrollments/:enrollmentId',
      name: 'TrialsByEnrollmentSpecific',
      props: true,
      component: TrialsByEnrollmentSpecific
    },
    {
      path: '/Trials/Locations',
      name: 'TrialsByLocation',
      component: TrialsByLocation
    },
    {
      path: '/Trials/locations/:locationId',
      name: 'TrialsByLocationSpecific',
      props: true,
      component: TrialsByLocationSpecific
    },
    {
      path: '/Trials/Indications',
      name: 'TrialsByIndication',
      component: TrialsByIndication
    },
    {
      path: '/Trials/indications/:indicationId',
      name: 'TrialsByIndicationSpecific',
      props: true,
      component: TrialsByIndicationSpecific
    },
    {
      path: '/Trials/Investigators',
      name: 'TrialsByInvestigator',
      component: TrialsByInvestigator
    },
    {
      path: '/Trials/investigators/:investigatorId',
      name: 'TrialsByInvestigatorSpecific',
      props: true,
      component: TrialsByInvestigatorSpecific
    },
    {
      path: '/Trials/Coordinators',
      name: 'TrialsByCoordinator',
      component: TrialsByCoordinator
    },
    {
      path: '/Trials/coordinators/:coordinatorId',
      name: 'TrialsByCoordinatorSpecific',
      props: true,
      component: TrialsByCoordinatorSpecific
    },
    {
      path: '/trials',
      name: 'Trials',
      component: Trials
    },
    {
      path: '/trial/new',
      name: 'CreateTrial',
      component: CreateTrial,
      beforeEnter: AuthGuard
    },
    {
      path: '/trials/:id',
      name: 'Trial',
      props: true,
      component: Trial
    },
    {
      path: '/trials/:id/edit',
      name: 'EditTrial',
      props: true,
      component: EditTrial
    },
    {
      path: '/enrollments',
      name: 'Enrollments',
      component: Enrollments
    },
    {
      path: '/enrollment/new',
      name: 'CreateEnrollment',
      component: CreateEnrollment,
      beforeEnter: AuthGuard
    },
    {
      path: '/Enrollments/:id',
      name: 'Enrollment',
      props: true,
      component: Enrollment
    },
    {
      path: '/locations',
      name: 'Locations',
      component: Locations
    },
    {
      path: '/location/new',
      name: 'CreateLocation',
      component: CreateLocation,
      beforeEnter: AuthGuard
    },
    {
      path: '/Locations/:id',
      name: 'Location',
      props: true,
      component: Location
    },
    {
      path: '/indications',
      name: 'Indications',
      component: Indications
    },
    {
      path: '/indication/new',
      name: 'CreateIndication',
      component: CreateIndication,
      beforeEnter: AuthGuard
    },
    {
      path: '/indications/:id',
      name: 'Indication',
      props: true,
      component: Indication
    },
    {
      path: '/investigators',
      name: 'Investigators',
      component: Investigators
    },
    {
      path: '/investigator/new',
      name: 'CreateInvestigator',
      component: CreateInvestigator,
      beforeEnter: AuthGuard
    },
    {
      path: '/investigator/:id',
      name: 'investigator',
      props: true,
      component: Investigator
    },
    {
      path: '/coordinators',
      name: 'Coordinators',
      component: Coordinators
    },
    {
      path: '/coordinator/new',
      name: 'CreateCoordinator',
      component: CreateCoordinator,
      beforeEnter: AuthGuard
    },
    {
      path: '/coordinator/:id',
      name: 'coordinator',
      props: true,
      component: Coordinator
    },
    {
      path: '/alerts',
      name: 'Alerts',
      component: Alerts
    },
    {
      path: '/alert/new',
      name: 'CreateAlert',
      component: CreateAlert,
      beforeEnter: AuthGuard
    },
    {
      path: '/alert/:id',
      name: 'alert',
      props: true,
      component: Alert
    },

    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      beforeEnter: AuthGuard
    },
    {
      path: '/signin',
      name: 'SignIn',
      component: SignIn
    },
    {
      path: '/signup',
      name: 'Signup',
      component: SignUp
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js